import { PureComponent } from 'react';
import i10n from '../../common/i10n';

function groupLLMKeys(keys) {
    // Créer un objet pour stocker les groupes
    const groups = {};

    keys.forEach(key => {
        // Extraire le nom du groupe (MRC_COMPRESSPDF ou CONVERTTOPDF)
        const groupMatch = key.match(/_LLM_([^_]+)/);
        if (!groupMatch) return;
        
        const groupName = groupMatch[1].toLowerCase();
        
        // Extraire le numéro de section et le type (TITLE ou BODY)
        const sectionMatch = key.match(/(\d+)_(TITLE|BODY(?:_\d+)?)/);
        if (!sectionMatch) return;
        
        const [, sectionNum, type] = sectionMatch;
        
        // Initialiser le groupe s'il n'existe pas
        if (!groups[groupName]) {
            groups[groupName] = {};
        }
        
        // Initialiser la section si elle n'existe pas
        if (!groups[groupName][sectionNum]) {
            groups[groupName][sectionNum] = {
                title: '',
                bodies: []
            };
        }
        
        // Ajouter le contenu en fonction du type
        if (type === 'TITLE') {
            groups[groupName][sectionNum].title = key;
        } else if (type.startsWith('BODY')) {
            groups[groupName][sectionNum].bodies.push(key);
        }
    });
    
    return groups;

    // {
    //     "mrc_compresspdf": {
    //     "1": {
    //         "title": "_LLM_MRC_COMPRESSPDF_1_TITLE",
    //             "bodies": ["_LLM_MRC_COMPRESSPDF_1_BODY"]
    //     },
    //     "2": {
    //         "title": "_LLM_MRC_COMPRESSPDF_2_TITLE",
    //             "bodies": [
    //             "_LLM_MRC_COMPRESSPDF_2_BODY_1",
    //             "_LLM_MRC_COMPRESSPDF_2_BODY_2"
    //         ]
    //     },
    //     // ...
//      },
    //     "converttopdf": {
    //     // Structure similaire...
//      }
    // }
}

export class LLMSection extends PureComponent {
    render() {
        console.log(this.props.tool.howToUseLocalizationKeyPart);
        const LlmLabels = i10n.getLLMSectionLabels(this.props.tool.howToUseLocalizationKeyPart);
        
        if (!LlmLabels) {
            return <></>;
        }
        
        const groups = groupLLMKeys(LlmLabels.map(i => i[0]));
        
        return <>
            {
                Object.entries(groups).map(([groupName, sections]) => (
                    <div key={groupName} className="llm-section">
                        {
                            Object.entries(sections).map(([sectionNum, section]) => (
                                <div key={sectionNum} className="llm-section-item">
                                    <h3>{i10n[section.title]}</h3>
                                    {
                                        section.bodies.map((bodyKey, index) => (
                                            <p key={index}>{i10n[bodyKey]}</p>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                ))
            }
        </>;
    }
}